module.exports = __webpack_public_path__ + "img/EmptyState.bbc2a8a1.jpg";